/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from "react"
import RootLayout from "./src/components/RootLayout/RootLayout"

export const wrapPageElement = ({ element }) => <RootLayout element={element} />
